// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__PcGzd","left":"Virtual_left__HKYIH","wrapper":"Virtual_wrapper__CDpAm"};